// @ts-ignore
type InputData = {
  links: { self: string };
  type: string;
  anchor: {
    id: string;
    createdAt: string;
    text: string;
    textHtml: string;
    explanation: string | null;
    explanationHtml: string | null;
    allowRandomDistractors: boolean;
    isStudiable: boolean;
    links: { self: string };
    type: string;
    sound: any;
    image: any;
    language: { id: string; type: string };
    partOfSpeech: any;
  };
  association: {
    id: string;
    createdAt: string;
    text: string;
    textHtml: string;
    explanation: string | null;
    explanationHtml: string | null;
    allowRandomDistractors: boolean;
    isStudiable: boolean;
    links: { self: string };
    type: string;
    sound: any;
    image: any;
    language: { id: string; type: string };
    partOfSpeech: any;
  };
};

type OutputData = {
  data: {
    id: number;
    type: string;
    attributes: {
      'allow-random-distractors': boolean;
      'created-at': string;
      explanation: string | null;
      'explanation-html': string | null;
      'is-studiable': boolean;
      text: string;
      'text-html': string;
    };
    callbacks: {};
    correct: boolean;
    isDuped: boolean;
    links: { self: string };
    relationships: {
      sound: { data: any };
      image: { data: any };
      language: { data: { id: number; type: string } };
      distractors: { data: any[] };
      'part-of-speech': { data: any };
    };
    saveData: {
      attributePathsToBeSaved: {};
      attributesPathsSaving: {};
    };
  };
};

export default function convertDataFormat(input: InputData): OutputData {
  return {
    data: {
      id: parseInt(input.association.id, 10),
      type: input.association.type,
      attributes: {
        'allow-random-distractors': input.association.allowRandomDistractors,
        'created-at': input.association.createdAt,
        explanation: input.association.explanation,
        'explanation-html': input.association.explanationHtml,
        'is-studiable': input.association.isStudiable,
        text: input.association.text,
        'text-html': input.association.textHtml,
      },
      callbacks: {},
      correct: false,
      isDuped: false,
      links: input.association.links,
      relationships: {
        sound: { data: input.association.sound },
        image: { data: input.association.image },
        language: {
          data: {
            id: parseInt(input.association.language.id, 10),
            type: input.association.language.type,
          },
        },
        distractors: { data: [] },
        'part-of-speech': { data: input.association.partOfSpeech },
      },
      saveData: {
        attributePathsToBeSaved: {},
        attributesPathsSaving: {},
      },
    },
  };
}
